<!-- 搜索栏 -->
<script setup>
  import { onMounted, onUnmounted, ref, watch } from 'vue';
  import { useRouter } from 'vue-router';
  import SearchBar from '../components/SearchBar.vue';
  import { usePage } from '../composables/usePage.js';
  import { articleApi } from '../api/index';
  import { useUserStore } from '@/stores/user';
  const store = useUserStore();

  const $router = useRouter();

  // 搜索相关
  const keywords = ref(''); // 总记录数
  const handleSearch = () => {
    search();
  };

  const dataList = ref([]);

  const search = async () => {
    console.log('keywords:', keywords.value);
    const params = {
      key: keywords.value,
      limit: pageSize.value,
      page: currentPage.value
    };
    const result = await articleApi.findList(params);
    console.log('result:', result);
    if (result && result.errcode === 0) {
      total.value = result.data.total;
      dataList.value = result.data.items;
    }
  };

  const handleEdit = id => {
    $router.push({ path: `/admin/noteedit/${id}` });
  };

  const handleDetail = id => {
    $router.push({ path: '/article/' + id });
  };

  onMounted(() => {
    console.log('111111111 onMounted');
    search();
  });

  onUnmounted(() => {
    console.log('111111111 onUnmounted');
  });

  // 分页信息
  const { total, currentPage, pageSize, pagerCount, handleCurrentChange } = usePage({ total: 0 });
  // 监控 page 变化，实现页面切换时重新加载数据
  watch(
    () => currentPage.value,
    () => {
      search();
    }
  );
  // 列表查询
</script>
<template>
  <div class="home-container">
    <el-row class="home-main">
      <el-col :span="24">
        <SearchBar v-model="keywords" @on-search="handleSearch"></SearchBar>

        <div class="home-list">
          <el-pagination
            :current-page="currentPage"
            :page-size="pageSize"
            :pager-count="pagerCount"
            :small="small"
            layout="->,total, prev, pager, next"
            :total="total"
            @current-change="handleCurrentChange"
          ></el-pagination>
          <ul>
            <li v-for="item in dataList" :key="item.id">
              <div class="data-card">
                <div class="item left" v-if="store.sig" @click="handleEdit(item.id)">
                  <i class="fa fa-edit"></i>
                </div>
                <div class="item center" @click="handleDetail(item.id)">
                  <h3>
                    <i v-if="item.privacy" style="margin-right: 5px" class="fa fa-lock"></i>
                    <i v-if="item.isTop" style="margin-right: 5px; color: orange" class="fa fa-flag"></i>
                    {{ item.title }}
                  </h3>
                  <p class="summary">{{ item.summary }}</p>
                </div>
                <div class="item right" @click="handleDetail(item.id)">
                  <i class="fa fa-angle-right"></i>
                </div>
              </div>
            </li>
            <li v-if="dataList.length === 0" class="empty-data">
              <p style="padding: 50px 0px">暂无数据</p>
            </li>
          </ul>
          <el-pagination
            :current-page="currentPage"
            :page-size="pageSize"
            :pager-count="pagerCount"
            :small="small"
            layout="->,total, prev, pager, next"
            :total="total"
            @current-change="handleCurrentChange"
          ></el-pagination>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<style lang="less" scoped>
  .home-container {
    padding-top: 20px;
    background-color: #f5f7f9;
    text-align: center;
    height: 100%;
    overflow-y: auto;

    .home-main {
      max-width: 860px;
      margin: 0 auto;
      margin-bottom: 80px;
    }

    .home-list {
      margin-top: 20px;
      .el-pagination {
        text-align: right;
        padding-top: 5px;
        padding-bottom: 5px;
        background: #ffffff;
        border-bottom: 1px solid #f3f3f3;
      }
    }

    ul {
      list-style: none;
      margin: 0px;
      text-align: left;
    }
    ul li {
      background: #fff;
    }
    ul li + li {
      border-top: 1px solid #f3f3f3;
    }

    .data-card {
      padding: 10px 0px 10px 10px;
      width: 100%;
      display: flex;
      color: #777;
    }

    .data-card .center {
      flex: 1;
    }

    .data-card .item:hover {
      cursor: pointer;
    }

    .data-card .center .summary {
      padding-top: 3px;
      font-size: 14px;
    }

    .data-card .left,
    .data-card .right {
      width: 50px;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .data-card .left-plus {
      width: 20px;
    }

    .data-card .left i {
      color: lightblue;
    }

    .data-card .right i {
      color: #bbb;
    }

    .empty-data {
      text-align: center;
      font-size: 16px;
      color: #777;
      padding: 20px auto;
    }
  }
</style>
